import { render, staticRenderFns } from "./StrengthBar.vue?vue&type=template&id=635bd350&scoped=true&"
import script from "./StrengthBar.vue?vue&type=script&lang=js&"
export * from "./StrengthBar.vue?vue&type=script&lang=js&"
import style0 from "./StrengthBar.vue?vue&type=style&index=0&id=635bd350&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bd350",
  null
  
)

export default component.exports